import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    value: { default: null },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    appendIcon: { default: 'mdi-calendar' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | null, disabled: boolean, readonly: boolean, appendIcon: string };





const menuOpen = ref(false)

const handleInput = (value: string) => {
  emit('input', value || null)
  menuOpen.value = false
}

return { __sfc: true,props, emit, menuOpen, handleInput }
}

})